import ErrorLink from "../components/ErrorLink";

function Error() {
  return <ErrorLink />;
}

export default Error;
